export default tabPanels => {
    // console.log('tabPanels');
    const contestPanelContainer = tabPanels.querySelector('.contest-panel-container');
    const radios = tabPanels.querySelectorAll('input[type="radio"]');
    const panels = tabPanels.querySelectorAll('.contest-panel');

    radios.forEach(radio => {
        radio.addEventListener('change', event => {
            if (event.target.checked) {
                panels.forEach(panel => panel.classList.remove('show'));

                tabPanels.querySelector(`#panel-${event.target.dataset.panel}`).classList.add('show');

                contestPanelContainer.style.height = `${tabPanels.querySelector(`#panel-${event.target.dataset.panel}`).offsetHeight}px`;
            }
        });
    });

    contestPanelContainer.style.height = `${tabPanels.querySelector('.contest-panel.show').offsetHeight}px`;
};
